/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_By_Speakers_SuccessInputs */

const en_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events merged by speakers successfully`)
};

const fr_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements fusionnés par locuteurs avec succès`)
};

const de_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die von den Rednern zusammengeführten Veranstaltungen wurden erfolgreich`)
};

const it_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi uniti con successo dagli oratori`)
};

const ru_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выступления докладчиков успешно объединили различные события.`)
};

const es_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos fusionados por oradores exitosamente`)
};

const zh_cn2_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者成功合并了活动`)
};

const ja_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者によるイベントの統合に成功しました`)
};

const hi_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं द्वारा सफलतापूर्वक विलय किए गए कार्यक्रम`)
};

const pt_pt2_event_group_options_merge_by_speakers_success = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos unificados pelos palestrantes com sucesso`)
};

/**
* | output |
* | --- |
* | "Events merged by speakers successfully" |
*
* @param {Event_Group_Options_Merge_By_Speakers_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers_success = /** @type {((inputs?: Event_Group_Options_Merge_By_Speakers_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_Speakers_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "de") return de_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "it") return it_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "ru") return ru_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "es") return es_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "ja") return ja_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "hi") return hi_event_group_options_merge_by_speakers_success(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_merge_by_speakers_success(inputs)
	return en_event_group_options_merge_by_speakers_success(inputs)
});